module.exports = __webpack_public_path__ + "static/img/methopedia-logo.8cd2aba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/methopedia-logo.png
// module id = 6
// module chunks = 1